/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import "./TopicValidator.scss";
import { BlockTypes } from "../Constants/BlockTypes";
import { findCheckboxes, findFieldBlocksOfType, findLabels } from "../Utils/HtmlUtils";
import { ValidationUtils } from "../Utils/ValidationUtils";
import { CssUtils } from "../CssUtils";
var TopicValidator = /** @class */ (function () {
    function TopicValidator() {
    }
    TopicValidator.prototype.attachValidation = function (form, config) {
        var _this = this;
        findFieldBlocksOfType(form, BlockTypes.blockTypePurpose).forEach(function (block) {
            _this.attachHandlers(form, block, config);
        });
    };
    TopicValidator.prototype.attachHandlers = function (form, block, config) {
        var _this = this;
        var checkboxes = findCheckboxes(block);
        if (checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.length) {
            // There should only ever be 1 checkbox for a specific purpose
            this.updateStateForPurpose(form, block, checkboxes[0], true);
            checkboxes.forEach(function (checkbox) {
                ValidationUtils.attachChangeEventHandler(checkbox, function () { return _this.updateStateForPurpose(form, block, checkboxes[0], false); });
                ValidationUtils.attachInvalidEventHandler(checkbox, function () { return _this.updateStateForPurpose(form, block, checkboxes[0], false); });
            });
        }
    };
    // Public for testability, do not use directly
    TopicValidator.prototype.updateStateForPurpose = function (form, block, purposeCheckbox, isInitializing) {
        // Enable/disable topics on the form that are associated with the specified purpose
        var _a;
        var purposeId = block.getAttribute("data-purposeid");
        var isPurposeOptInWhenChecked = ((_a = block.getAttribute("data-optinwhenchecked")) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "true";
        var isPurposeChecked = purposeCheckbox.checked;
        var topicsAreEnabled = (isPurposeChecked && isPurposeOptInWhenChecked) || (!isPurposeChecked && !isPurposeOptInWhenChecked);
        // Find all topic blocks
        findFieldBlocksOfType(form, BlockTypes.blockTypeTopic).forEach(function (topicBlock) {
            var _a;
            var topicPurposeId = topicBlock.getAttribute("data-purposeid");
            if (topicPurposeId && purposeId && topicPurposeId.toLocaleLowerCase() === purposeId.toLowerCase()) {
                var isTopicOptInWhenChecked_1 = ((_a = topicBlock.getAttribute("data-optinwhenchecked")) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "true";
                // Set the enabled/disabled state of the input controls/labels in this block
                var checkboxes = findCheckboxes(topicBlock);
                checkboxes.forEach(function (topicCheckbox) {
                    topicCheckbox.disabled = !topicsAreEnabled;
                    if (isInitializing) {
                        // Save the initial state for later use
                        topicCheckbox.dataset.checkedByDefault = topicCheckbox.checked ? "true" : "false";
                    }
                    if (topicsAreEnabled) {
                        if (!isInitializing) {
                            var isCheckedByDefault = topicCheckbox.dataset.checkedByDefault === "true";
                            topicCheckbox.checked = isCheckedByDefault;
                        }
                    }
                    else {
                        topicCheckbox.checked = !isTopicOptInWhenChecked_1;
                    }
                });
                var labels = findLabels(topicBlock);
                labels.forEach(function (topicLabel) {
                    if (topicsAreEnabled) {
                        CssUtils.removeClass(topicLabel, "topic-disabled-text");
                    }
                    else {
                        CssUtils.addClass(topicLabel, "topic-disabled-text");
                    }
                });
            }
        });
    };
    return TopicValidator;
}());
export { TopicValidator };
